export var ResultStatusObj = {
    FULFILLED: "fulfilled",
    REJECTED: "rejected",
};
